import { render } from "./DetailIngredientsView.vue?vue&type=template&id=b29ff508&scoped=true&ts=true"
import script from "./DetailIngredientsView.vue?vue&type=script&lang=ts"
export * from "./DetailIngredientsView.vue?vue&type=script&lang=ts"

import "./DetailIngredientsView.vue?vue&type=style&index=0&id=b29ff508&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b29ff508"]])

export default __exports__